// extracted by mini-css-extract-plugin
export var callCard = "_sa-0";
export var callMessageButton = "_sa-1";
export var helpIcon = "_sa-3";
export var helpIconContainer = "_sa-4";
export var verticalDivider = "_sa-2";